import { useState, useRef, CSSProperties } from "react";
import React from "react";

interface Props {
    text?: string;
    justify?: "left" | "center" | "right";
    style?: CSSProperties;
    thickness?: number;
    padding?: string;
}
export default function HSeparator({
    text,
    style,
    padding,
    justify = "center",
    thickness = 3,
}: Props) {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                ...(padding ? { padding } : {}),
            }}
        >
            {(!justify || justify !== "left") && (
                <div
                    style={{
                        flex: 1,
                        backgroundColor: "var(--accent-a)",
                        height: `${thickness}px`,
                        margin: "auto  0.25em",
                    }}
                ></div>
            )}
            {text && <div style={style}>{text}</div>}
            {(!justify || justify !== "right") && (
                <div
                    style={{
                        flex: 1,
                        backgroundColor: "var(--accent-a)",
                        height: `${thickness}px`,
                        margin: "auto 0.25em",
                    }}
                ></div>
            )}
        </div>
    );
}
